module.exports = __webpack_public_path__ + "static/media/27-5.734c3862.mp3";